import { type ReactNode } from 'react';

type UserRole = 'submitter' | 'pastor' | 'minister_of_music' | 'musician' | 'media_team' | 'admin' | 'finance_team';

interface HeaderProps {
  title: string;
  subtitle?: string;
  role?: UserRole;
  rightAction?: ReactNode;
  className?: string;
}

const ROLE_GRADIENTS: Record<UserRole, string> = {
  submitter: 'bg-gradient-to-r from-primary to-primary-light',
  pastor: 'bg-gradient-to-r from-primary-dark to-primary',
  minister_of_music: 'bg-gradient-to-r from-music to-recall',
  musician: 'bg-gradient-to-r from-music to-recall',
  media_team: 'bg-gradient-to-r from-primary to-primary-light',
  admin: 'bg-gradient-to-r from-primary-dark to-primary',
  finance_team: 'bg-gradient-to-r from-primary-dark to-primary',
};

export function Header({
  title,
  subtitle,
  role = 'submitter',
  rightAction,
  className = '',
}: HeaderProps) {
  const gradient = ROLE_GRADIENTS[role];

  return (
    <header
      className={`
        ${gradient}
        px-5 py-4 md:px-6 lg:px-8
        text-white
        animate-entrance
        ${className}
      `.trim().replace(/\s+/g, ' ')}
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <h1 className="text-h1 font-bold leading-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="text-body-sm font-normal opacity-80 mt-0.5">
              {subtitle}
            </p>
          )}
        </div>
        {rightAction && (
          <div className="ml-4">
            {rightAction}
          </div>
        )}
      </div>
    </header>
  );
}
